
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({
  name: "HeaderSearch",
})
export default class HeaderSearch extends Vue {
  private searchText = '';
  private textSearchTimer;

  onSearchTextChanged(value: string, oldValue: string) {
    clearTimeout(this.textSearchTimer);
    this.textSearchTimer = setTimeout(() => {
      this.searchText = value;
      const path = (this.$router.currentRoute.path !== "/produtos" ? {path: "/produtos"} : null)
      this.$router.push({...path, query: {prodSearch: this.searchText || undefined}});
    }, 600);
  }

  @Watch("$route.query", {deep: true })
  onQueryChanged(value: any, oldValue: any) {
    const {prodSearch} = value;
    if (prodSearch !== this.searchText) {
      this.searchText = prodSearch;
    }
  }

  // dislpayViewport() {
  //   return (
  //     (this.$vuetify.breakpoint.xs && "xs") ||
  //     (this.$vuetify.breakpoint.sm && "sm") ||
  //     (this.$vuetify.breakpoint.md && "md") ||
  //     (this.$vuetify.breakpoint.lg && "lg") ||
  //     (this.$vuetify.breakpoint.xl && "xl") ||
  //     "NULO"
  //   );
  // }
}
